"use client"

import { ShippingCountryCode } from "@/data/shipping-country-code"
import { LanguageOption } from "@/data/supported-languages"
import CountryPicker from "../CountryPicker"
import CountryPickerButton from "../CountryPickerButton"
export interface Country {
    value: string
    label: string
    isSelected: boolean
    countryCode: string
}

type CountryPickerWrapperProps = {
    countries: Country[]
    countriesWithLanguages: Record<ShippingCountryCode, LanguageOption[]>
    fallbackCentraSessionData: {
        countryCode?: string
        langCode?: string
    }
    locale: string
    extractedAbsolutePath: string | null
}

const CountryPickerWrapper = ({
    countries,
    countriesWithLanguages,
    fallbackCentraSessionData,
    locale,
    extractedAbsolutePath
}: CountryPickerWrapperProps) => {
    return (
        <>
            <CountryPicker
                countries={countries}
                countriesWithLanguages={countriesWithLanguages}
                extractedAbsolutePath={extractedAbsolutePath}
            />
            <CountryPickerButton
                fallbackCentraSessionData={fallbackCentraSessionData}
                locale={locale}
            />
        </>
    )
}

export default CountryPickerWrapper
